module.exports = __webpack_public_path__ + "static/media/lexus-logo.e0893d04.svg";